<template>
    <div>
        <el-dialog :visible.sync="withdrawDetailDialog" width="50%" top="8vh" center style="border: 1px solid #01DFD7" :close-on-click-modal = false
               :close-on-press-escape = false v-loading="loading"  element-loading-text="请求处理中" element-loading-spinner="el-icon-loading"  
               element-loading-background="rgba(0.8, 0, 0, 0.3)" @close="closeDialog">
        <el-card>
            <el-tabs type="border-card" v-model="activeName">
                <el-tab-pane label="用户信息" name="1">
                    <el-form ref="dateForm" label-width="85px" label-position="left">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item>
                                        <label slot="label">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名称</label>
                                        {{response.data.registerName}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item>
                                       <label slot="label">&nbsp;&nbsp;&nbsp;&nbsp;联系电话</label>
                                       {{response.data.phone}}
                                     </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item>
                                        <label slot="label">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;类型</label>
                                        {{response.data.typeStr}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item>
                                       <label slot="label">&nbsp;&nbsp;&nbsp;&nbsp;主体名称</label>
                                       {{response.data.subjectName}}
                                     </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item>
                                       <label slot="label">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;地区</label>
                                       {{response.data.provinceStr}}{{response.data.cityStr}}{{response.data.areaStr}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item>
                                       <label slot="label">&nbsp;&nbsp;&nbsp;&nbsp;营业执照</label>
                                     </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="身份证反面"></el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="身份证正面"></el-form-item>
                                </el-col>
                            </el-row>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane label="提现信息" name="2">
                    <el-form ref="dateForm" label-width="85px" label-position="left">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="提现订单号">{{response.data.withdrawId}}</el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item>
                                       <label slot="label">&nbsp;&nbsp;&nbsp;&nbsp;提现方式</label>
                                       {{response.data.wayStr}}
                                     </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="可提现余额">{{response.data.withdrawAble}}</el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item>
                                       <label slot="label">&nbsp;&nbsp;&nbsp;&nbsp;提现金额</label>
                                       {{response.data.withdrawMoney}}
                                     </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item>
                                       <label slot="label">&nbsp;&nbsp;&nbsp;&nbsp;到账金额</label>
                                       {{response.data.realPayment}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="提现手续费">
                                        {{response.data.rateMoney}}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="提现服务费">
                                       {{response.data.serviceMoney}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item>
                                       <label slot="label">&nbsp;&nbsp;&nbsp;&nbsp;扣税方式</label>
                                     </el-form-item>
                                </el-col>
                            </el-row>
                             <el-row>
                                <el-col :span="12">
                                    <el-form-item>
                                       <label slot="label">&nbsp;&nbsp;&nbsp;&nbsp;扣税凭证</label>
                                     </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item>
                                       <label slot="label">&nbsp;&nbsp;&nbsp;&nbsp;申请时间</label>
                                       {{response.data.createTime | formatDate}}
                                     </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item>
                                        <label slot="label">&nbsp;&nbsp;&nbsp;&nbsp;提现状态</label>
                                            {{response.data.stateStr}}
                                        </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item>
                                        <label slot="label">&nbsp;&nbsp;&nbsp;&nbsp;审批提现</label>
                                            <el-button type="warning" size="small" plain v-if="response.data.state === '0'" @click="approvalApply">审核通过</el-button>
                                            <el-button type="warning" size="small" plain v-if="response.data.state === '0'" @click="refuseApply">拒绝审核</el-button>
                                            <el-button type="warning" size="small" plain v-if="response.data.state === '1'" @click="transfer">放款</el-button>
                                            <el-button type="warning" size="small" plain v-if="response.data.state === '-2'" @click="transferDone">放款完成</el-button>
                                            <el-button type="warning" size="small" plain v-if="response.data.state === '-2'" @click="transferFail">放款失败</el-button>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane label="银行卡信息" name="3">
                    <el-form ref="dateForm" label-width="85px" label-position="left">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item>
                                        <label slot="label">&nbsp;&nbsp;&nbsp;&nbsp;收款户名</label>
                                        {{response.data.realName}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item>
                                       <label slot="label">&nbsp;&nbsp;&nbsp;&nbsp;开户银行</label>
                                     </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item>
                                        <label slot="label">&nbsp;&nbsp;&nbsp;&nbsp;收款账号</label>
                                        {{response.data.bankCard}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="预留手机号">
                                       {{response.data.bankPhone}}
                                     </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item>
                                        <label slot="label">&nbsp;&nbsp;&nbsp;&nbsp;身份证号</label>
                                        {{response.data.identityCard}}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane label="门店列表" name="4">
                    <el-table :data="response.data.withdrawStoreDtoList" style="margin:auto;width:calc(100% - 30px)" height="400" border
                        :header-cell-style="{background:'#01DFD7',color:'#fff'}" element-loading-background="rgba(0.8, 0, 0, 0.3)">
                        <el-table-column label="门店编号" align="center" prop="code"></el-table-column>
                        <el-table-column label="门店名称" align="center" prop="name"></el-table-column>
                        <el-table-column label="所在地区" align="center" width="200">
                            <template slot-scope="scope">{{scope.row.provinceStr}}{{scope.row.cityStr}}{{scope.row.areaStr}}</template>
                        </el-table-column>
                        <el-table-column label="订单总数" align="center" prop="orderCount"></el-table-column>
                        <el-table-column label="订单总金额" align="center" prop="orderMoneySum"></el-table-column>
                        <el-table-column label="订单实付" align="center" prop="orderPayMoneySum"></el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane label="审批信息" name="5">
                    <el-table :data="response.data.withdrawAuditHisDtoList" style="margin:auto;width:calc(100% - 30px)" height="400" border
                        :header-cell-style="{background:'#01DFD7',color:'#fff'}" element-loading-background="rgba(0.8, 0, 0, 0.3)">
                        <el-table-column label="ID" align="center" prop="id"></el-table-column>
                        <el-table-column label="状态" align="center" prop="stateStr"></el-table-column>
                        <el-table-column label="审核人" align="center" prop="createUser"></el-table-column>
                        <el-table-column label="内容" align="center" prop="content"></el-table-column>
                        <el-table-column label="审核时间" align="center">
                             <template slot-scope="scope">{{scope.row.createTime | formatDate}}</template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
        </el-card>
    </el-dialog>
    </div>
</template>
<script>
import {getPendingApprovalById, approval, refuseWithdraw, transfer, confirmTransfer, transferFail} from '../../../api/withdraw/withdrawapply.js'
import { formatDate } from "../../../utils/date";
export default {
    data() {
        return {
            withdrawDetailDialog: false,
            loading: false,
            item: '',
            response: {data: ''},
            activeName: "1"
        }
    },
    methods: {
        init(item){
            this.item = item;
            this.withdrawDetailDialog = true;
            getPendingApprovalById(item.account,item.id).then(result=>{
                this.response.data = result.data;
            })
        },

        /**
         * 关闭弹窗
         */
        closeDialog(){
            this.activeName = "1";
            this.response.data = "";
            this.withdrawDetailDialog = false;
        },

        /**
         * 审核通过
         */
        approvalApply(){
            this.$confirm('确认是否操作?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                approval({withdrawId: this.response.data.withdrawId}).then(result=>{
                    if(result.code === '000000'){
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 3000
                        });
                        getPendingApprovalById(this.item.account,this.item.id).then(result=>{
                            this.response.data = result.data;
                            this.$emit("succeed");
                        })
                    }
                })
            })
        },

        /**
         * 拒绝审核
         */
        refuseApply(){
            this.$prompt('拒绝原因', '', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                showClose: false
                }).then(({ value }) => {
                    refuseWithdraw({withdrawId: this.response.data.withdrawId, reason: value}).then(result=>{
                        if(result.code === "000000"){
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 3000
                            });
                            getPendingApprovalById(this.item.account,this.item.id).then(result=>{
                                this.response.data = result.data;
                                this.$emit("succeed");
                            })
                        }
                    })
            })
        },

        /**
         * 打款
         */
        transfer(){
            this.$confirm('确认是否操作?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                transfer({withdrawId: this.response.data.withdrawId}).then(result=>{
                    if(result.code === '000000'){
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 3000
                        });
                        getPendingApprovalById(this.item.account,this.item.id).then(result=>{
                            this.response.data = result.data;
                            this.$emit("succeed");
                        })
                    }
                })
            })
        },

        /**
         * 打款完成
         */
        transferDone(){
            this.$confirm('确认是否操作?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                confirmTransfer({withdrawId: this.response.data.withdrawId}).then(result=>{
                    if(result.code === '000000'){
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 3000
                        });
                        getPendingApprovalById(this.item.account,this.item.id).then(result=>{
                            this.response.data = result.data;
                            this.$emit("succeed");
                        })
                    }
                })
            })
        },

        /**
         * 打款失败
         */
        transferFail(){
            this.$prompt('失败原因', '', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                showClose: false
                }).then(({ value }) => {
                    transferFail({withdrawId: this.response.data.withdrawId, reason: value}).then(result=>{
                        if(result.code === "000000"){
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 3000
                            });
                            getPendingApprovalById(this.item.account,this.item.id).then(result=>{
                                this.response.data = result.data;
                                this.$emit("succeed");
                            })
                        }
                    })
            })
        }
    },
    filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
  },
}
</script>
<style scoped>
.el-tab-pane{
    height: 400px;
}
</style>


// WEBPACK FOOTER //
// src/pages/finance/withdrawmanagement/withdrawdetail.vue